import { TipoDeRecurso } from '@/models/Recurso'
import { tituloDaToolbarPeloNomeDaRota } from '@/shareds/router-shareds'
import { RouteConfig } from 'vue-router'

const rotas: RouteConfig[] = [
	{
		path: 'estacao',
		name: 'Estações',
		components: {
			default: () =>
				import('@/views/application/produtos/TelaDeEstacoes.vue'),
			toolbar: () =>
				import('@/components/layout/AppToolbarComTitulo.vue'),
		},
		props: {
			toolbar: tituloDaToolbarPeloNomeDaRota,
		},
		meta: {
			recurso: 'estacao' as TipoDeRecurso,
		},
	},
]

export default rotas